export enum PositionEnum {
  FRONTEND = "Frontend Developer",
  BACKEND = "Backend Developer",
  FULL_STACK = "FullStack Developer",
  DESIGNER = "Designer",
  BA = "Business Analyst",
  QA = "QA Engineer",
  SALES = "Sales Manager",
  PM = "Project Manager",
  MOBILE = "Mobile Developer",
  DEV_OPS = "DevOps Engineer",
}
